
<div class="grid-gridedit-wrapper">
  
  <div class="grid-row-1-col-1">
      <dx-box direction="row"
      align="left"
      width="100%">
        <dxi-item [baseSize]="50">
          <dx-button [height]="45" icon="chevronleft"
                    (onClick)="prevWeek_Click()">
          </dx-button>
        </dxi-item>
        <dxi-item [baseSize]="320">
          <dx-drop-down-box [height]="45" width="auto" fieldTemplate="field">
            <dx-calendar  minZoomLevel="decade" [zoomLevel]="zoomLevels[0]" [firstDayOfWeek]="1"
                        maxZoomLevel="month" (onValueChanged)="weekChanged($event)">
            </dx-calendar>
            <div *dxTemplate="let data of 'field'">
                <dx-text-box [value]="weekno_text" [readOnly]="true" [height]="47"></dx-text-box>
            </div>
          </dx-drop-down-box>
        </dxi-item>
        <dxi-item [baseSize]="50">
          <dx-button [height]="45" icon="chevronright"
                    (onClick)="nextWeek_Click()">
          </dx-button>
        </dxi-item>
        <dxi-item [baseSize]="100" style="margin-left: 20px">
          <dx-button [text]="todayText" style="height: 45px;"
                    (onClick)="today_Click()">
          </dx-button>
        </dxi-item>
      </dx-box>
  </div>
  <div *ngIf="isEmployeeSelectShown === true" class="grid-row-2-col-1">
      <dx-select-box [height]="45" [dataSource]="employees" displayExpr="FullName" [placeholder]="placeholderEmployeeSelect"
                     valueExpr="EmployeeId" [(value)]="selectedEmployeeId" [visible]="isEmployeeSelectShown"
                     [showClearButton]="true" (onSelectionChanged)="onSelectionChangedEmployees($event)">
      </dx-select-box>
  </div>
</div>
<div class="mat-elevation-z10" style="padding: 20px; margin-right:20px">
  <dx-data-grid id="gridContainer"
                [dataSource]="dataSourceWeekApproval"
                keyExpr="ProjectId"
                [showBorders]="true"
                [allowColumnReordering]="true"
                (onInitNewRow)="onInitNewRow($event)"
                (onRowInserting)="onRowInserting($event)"
                (onRowUpdating)="onRowUpdating($event)"
                (onEditorPreparing)="onEditorPreparing($event)"
                (onCellPrepared)="onCellPrepared($event)"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                [allowColumnResizing]="true"
                columnResizingMode="nextColumn"
                [rowAlternationEnabled]="true">

    <!-- <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping> -->
    <dxo-paging [pageSize]="15"></dxo-paging>
    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-editing [mode]="editMode" [useIcons]="true" 
                [allowUpdating]="true" [allowAdding]="allowAdding" >
    </dxo-editing>
    <dxo-selection
      mode="multiple"
      showCheckBoxesMode="always">
    </dxo-selection>

    <dxi-column dataField="StatusId" caption=" " cellTemplate="cellTemplateStatus" [width]="55" [allowEditing]="false" calculateSortValue="StatusId" calculateGroupValue="StatusDescription" >
      <dxo-header-filter [dataSource]="headerFilterData"></dxo-header-filter>
    </dxi-column>
    <dxi-column dataField="ProjectDisplayName"   [caption]="projectText" cellTemplate="projectTemplate"  editCellTemplate="projectEditTemplate"  [setCellValue]="setProjectValue"></dxi-column>
    <dxi-column dataField="EmployeeId" [visible]="false"></dxi-column>
    <dxi-column dataField="EmployeeName"  [caption]="employeeText" cellTemplate="employeeCellTemplate" editCellTemplate="employeeEditTemplate" alignment="left" [visible]="isEmployeeColumnShown"  [setCellValue]="setEmployeeValue"  >
    </dxi-column>
    <!-- <dxi-column dataField="EmployeeId" [width]="250" [caption]="employeeText" [allowEditing]="employeeLookUpEnabled" [visible]="isEmployeeSelectShown"    >
      <dxo-lookup [dataSource]="employees" 
                  displayExpr="FullName" 
                  valueExpr="EmployeeId">
      </dxo-lookup>
    </dxi-column> -->
    <dxi-column dataField="TimeTypeDisplayName" [caption]="timetypeText" [width]="120" editCellTemplate="timetypeEditTemplate"  [setCellValue]="setTimeTypeValue"  >
    </dxi-column>
    <dxi-column [caption]="mondayHeader" class="centerheader thiccBorder" alignment="center" >
      <dxi-column dataField="MondaySecondsToHH" dataType="number" [caption]="placeholderShortHours" [allowHeaderFiltering]="false" [width]="45"  alignment="right" [editorOptions]="{ valueChangeEvent: 'input' }"   >
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="MondaySecondsTomm" dataType="number" [caption]="placeholderShortMinutes" [allowHeaderFiltering]="false" [width]="35"  alignment="left" [editorOptions]="{ valueChangeEvent: 'input' }"  >
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
    </dxi-column>
    <dxi-column [caption]="tuesdayHeader" class="centerheader" alignment="center" >
      <dxi-column dataField="TuesdaySecondsToHH" [caption]="placeholderShortHours" [allowHeaderFiltering]="false" [width]="45"  alignment="right" [editorOptions]="{ valueChangeEvent: 'input' }"  >
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="TuesdaySecondsTomm" [caption]="placeholderShortMinutes" [allowHeaderFiltering]="false" [width]="35"  alignment="left" [editorOptions]="{ valueChangeEvent: 'input' }" >
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
    </dxi-column>
    <dxi-column [caption]="wednesdayHeader" class="centerheader" alignment="center">
      <dxi-column dataField="WednesdaySecondsToHH" [caption]="placeholderShortHours" [allowHeaderFiltering]="false" [width]="45"  alignment="right" [editorOptions]="{ valueChangeEvent: 'input' }"  >
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="WednesdaySecondsTomm" [caption]="placeholderShortMinutes" [allowHeaderFiltering]="false" [width]="35"  alignment="left" [editorOptions]="{ valueChangeEvent: 'input' }" >
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
    </dxi-column>
    <dxi-column [caption]="thursdayHeader" class="centerheader" alignment="center">
      <dxi-column dataField="ThursdaySecondsToHH" [caption]="placeholderShortHours" [allowHeaderFiltering]="false" [width]="45"  alignment="right" [editorOptions]="{ valueChangeEvent: 'input' }"  >
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="ThursdaySecondsTomm" [caption]="placeholderShortMinutes" [allowHeaderFiltering]="false" [width]="35"  alignment="left" [editorOptions]="{ valueChangeEvent: 'input' }" >
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
    </dxi-column>
    <dxi-column [caption]="fridayHeader" class="centerheader" alignment="center">
      <dxi-column dataField="FridaySecondsToHH" [caption]="placeholderShortHours" [allowHeaderFiltering]="false" [width]="45"  alignment="right" [editorOptions]="{ valueChangeEvent: 'input' }"  >
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="FridaySecondsTomm" [caption]="placeholderShortMinutes" [allowHeaderFiltering]="false" [width]="35"  alignment="left" [editorOptions]="{ valueChangeEvent: 'input' }" >
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
    </dxi-column>
    <dxi-column [caption]="saturdayHeader" class="centerheader" alignment="center">
      <dxi-column dataField="SaturdaySecondsToHH" [caption]="placeholderShortHours" [allowHeaderFiltering]="false" [width]="45"  alignment="right" [editorOptions]="{ valueChangeEvent: 'input' }"  >
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="SaturdaySecondsTomm" [caption]="placeholderShortMinutes" [allowHeaderFiltering]="false" [width]="35"  alignment="left" [editorOptions]="{ valueChangeEvent: 'input' }" >
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
    </dxi-column>
    <dxi-column [caption]="sundayHeader" class="centerheader" alignment="center">
      <dxi-column dataField="SundaySecondsToHH" [caption]="placeholderShortHours" [allowHeaderFiltering]="false" [width]="45"  alignment="right" [editorOptions]="{ valueChangeEvent: 'input' }"  >
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="SundaySecondsTomm" [caption]="placeholderShortMinutes" [allowHeaderFiltering]="false" [width]="35"  alignment="left" [editorOptions]="{ valueChangeEvent: 'input' }" >
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
    </dxi-column>
    <!-- <dxi-column dataField="MondaySeconds" [caption]="mondayHeader" cellTemplate="mondayCellTemplate" editCellTemplate="mondayEditCellTemplate" [allowHeaderFiltering]="false" [width]="85"  alignment="right"  [setCellValue]="setMondayValue" ></dxi-column>
    <dxi-column dataField="TuesdaySeconds" [caption]="tuesdayHeader" cellTemplate="tuesdayCellTemplate" editCellTemplate="tuesdayEditCellTemplate" [allowHeaderFiltering]="false" [width]="85" alignment="right" [setCellValue]="setTuesdayValue" ></dxi-column>
    <dxi-column dataField="WednesdaySeconds" [caption]="wednesdayHeader" cellTemplate="wednesdayCellTemplate" editCellTemplate="wednesdayEditCellTemplate" [allowHeaderFiltering]="false" [width]="85" alignment="right" [setCellValue]="setWednesdayValue"></dxi-column>
    <dxi-column dataField="ThursdaySeconds" [caption]="thursdayHeader" cellTemplate="thursdayCellTemplate" editCellTemplate="thursdayEditCellTemplate" [allowHeaderFiltering]="false" [width]="85" alignment="right" [setCellValue]="setThursdayValue"></dxi-column>
    <dxi-column dataField="FridaySeconds" [caption]="fridayHeader" cellTemplate="fridayCellTemplate"  editCellTemplate="fridayEditCellTemplate" [allowHeaderFiltering]="false" [width]="85" alignment="right" [setCellValue]="setFridayValue"></dxi-column>
    <dxi-column dataField="SaturdaySeconds" [caption]="saturdayHeader" cellTemplate="saturdayCellTemplate" editCellTemplate="saturdayEditCellTemplate" [allowHeaderFiltering]="false" [width]="85" alignment="right" [setCellValue]="setSaturdayValue"></dxi-column>
    <dxi-column dataField="SundaySeconds" [caption]="sundayHeader" cellTemplate="sundayCellTemplate"  editCellTemplate="sundayEditCellTemplate" [allowHeaderFiltering]="false" [width]="85" alignment="right" [setCellValue]="setSundayValue"></dxi-column> -->
    <!-- <dxi-column name="copyColumn" [caption]="copyText" cellTemplate="copyCellTemplate" [width]="85"></dxi-column> -->
    <!-- <dxi-column caption="Delete" cellTemplate="deleteCellTemplate" [width]="60"></dxi-column> -->
      <div *dxTemplate="let c of 'cellTemplateStatus'">
              
      </div>
    <div *dxTemplate="let data of 'projectTemplate'">
      <span [title]="data.data.ProjectDisplayToolTip">{{data.data.ProjectDisplayName}}</span>
    </div>
    <div *dxTemplate="let data of 'projectEditTemplate'">
      <span style="padding-left: 7px" *ngIf="data.data.StatusId >= 4 || (data.data.StatusId === 3 && !this.allowEditConfirmed) || (data.data.CategoryId === 1 || data.data.CategoryId === 7 && data.data.StatusId === 2 && !allowEditUnconfirmed); else edit_project_select" [title]="data.data.ProjectDisplayToolTip">{{data.data.ProjectDisplayName}}</span>
      <ng-template #edit_project_select>
        <dx-box direction="row"
          width="100%">
          <dxi-item  [ratio]="5">
            <div>
              <dx-select-box [dataSource]="projectsDataSource"
                          displayExpr="ProjectDisplayName"
                          searchExpr="ProjectDisplayName"
                          valueExpr="ProjectId"
                          (onValueChanged)="onProjectValueChanged($event, data)"
                          [searchEnabled]="true"
                          [height]="35"
                          [showClearButton]="true"
                          [placeholder]="placeholderProjectSelectSearch"
                          [value]="data.data.ProjectId">
              </dx-select-box>
            </div>
          
            
          </dxi-item>
          <dxi-item [ratio]="1">
            <dx-button style="margin-left: 2px; margin-right: 2px"  icon="search" [height]="35" (onClick)="showPopupProject(data.data.ProjectId, data.data.CustomerId, data)"></dx-button>
          </dxi-item>
        </dx-box>
      </ng-template>

    </div>
    <div *dxTemplate="let data of 'employeeCellTemplate'">
      <span>{{data.data.EmployeeName}}</span>
    </div>
    <div *dxTemplate="let data of 'employeeEditTemplate'">
      <span style="padding-left: 7px" *ngIf="data.data.StatusId >= 4 || (data.data.StatusId === 3 && !this.allowEditConfirmed) || (data.data.CategoryId === 1 || data.data.CategoryId === 7 && data.data.StatusId === 2 && !allowEditUnconfirmed); else edit_employee_select">{{data.data.EmployeeName}}</span>
      <ng-template #edit_employee_select>
      <dx-select-box 
                      [dataSource]="employees"
                      displayExpr="FullName"
                      searchExpr="FullName"
                      valueExpr="EmployeeId"
                      (onValueChanged)="onEmployeeValueChanged($event, data)"
                      [searchEnabled]="true"
                      [height]="35"
                      [showClearButton]="true"
                      [value]="data.data.EmployeeId">
          </dx-select-box>
        </ng-template>
      
    </div>
    <div *dxTemplate="let data of 'timetypeEditTemplate'">
      <span style="padding-left: 7px" *ngIf="data.data.StatusId >= 4 || (data.data.StatusId === 3 && !this.allowEditConfirmed) || (data.data.CategoryId === 1 || data.data.CategoryId === 7 && data.data.StatusId === 2 && !allowEditUnconfirmed); else edit_timetype_select">{{data.data.TimeTypeDisplayName}}</span>
      <ng-template #edit_timetype_select>
      <dx-select-box 
                      [dataSource]="timetypes"
                      displayExpr="Code"
                      searchExpr="Code"
                      valueExpr="TimeTypeId"
                      (onValueChanged)="onTimeTypeValueChanged($event, data)"
                      [searchEnabled]="true"
                      [height]="35"
                      [value]="data.data.TimeTypeId">
          </dx-select-box>
        </ng-template>
    </div>
    <div *dxTemplate="let data of 'groupEmployee'">
      <span>{{data.data.EmployeeId}}</span>
    </div>
    <div *dxTemplate="let data of 'dayHeaderTemplate'">
      <p class="centerheader" >{{data.column.caption}}</p>
    </div>
    <div *dxTemplate="let data of 'mondayCellTemplate'">
      <span>{{data.data.MondayToHHmm}}</span>
    </div>
    <div *dxTemplate="let data of 'mondayEditCellTemplate'">
      <dx-box direction="row"
              width="100%">
        <dxi-item  [ratio]="2">
          <dx-number-box [value]="getValueHours(data)" [min]="0" [max]="24" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownHH($event)" placeholder="{{placeholderShortHours}}" (onValueChanged)="onValueChangedHours($event, data, 1)"></dx-number-box>
        </dxi-item>
        <dxi-item [ratio]="2">
          <dx-number-box class="alignRight" [value]="data.displayValue" [disabled]="data.data.StatusId === 4" [min]="0" [max]="59" (onFocusIn)="focusHHmm($event)" placeholder="{{placeholderShortMinutes}}" (onKeyDown)="onKeyDownMinutes($event, data, 1)" (onValueChanged)="onValueChangedMinutes($event, data, 1)"></dx-number-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *dxTemplate="let data of 'mondayMinEditCellTemplate'">
          <dx-number-box class="alignRight" [value]="data.data.MondaySecondsTomm" [disabled]="data.data.StatusId === 4" [min]="0" [max]="59" (onFocusIn)="focusHHmm($event)" placeholder="{{placeholderShortMinutes}}" (onKeyDown)="onKeyDownMinutes($event, data, 1)" (onValueChanged)="onValueChangedMinutes($event, data, 1)"></dx-number-box>
    </div>
    <div *dxTemplate="let data of 'tuesdayCellTemplate'">
      <span>{{data.data.TuesdayToHHmm}}</span>
    </div>
    <div *dxTemplate="let data of 'tuesdayEditCellTemplate'">
      <dx-box direction="row"
              width="100%">
        <dxi-item  [ratio]="2">
          <dx-number-box [value]="getValueHours(data)" [min]="0" [max]="24" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownHH($event)" (onValueChanged)="onValueChangedHours($event, data, 2)" placeholder="{{placeholderShortHours}}"></dx-number-box>
        </dxi-item>
        <dxi-item [ratio]="2">
          <dx-number-box [value]="getValueMin(data)" [min]="0" [max]="59" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownMinutes($event, data, 2)" (onValueChanged)="onValueChangedMinutes($event, data, 2)" placeholder="{{placeholderShortMinutes}}"></dx-number-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *dxTemplate="let data of 'tuesdayMinEditCellTemplate'">
          <dx-number-box class="alignRight" [value]="data.displayValue" [disabled]="data.data.StatusId === 4" [min]="0" [max]="59" (onFocusIn)="focusHHmm($event)" placeholder="{{placeholderShortMinutes}}" (onKeyDown)="onKeyDownMinutes($event, data, 2)" (onValueChanged)="onValueChangedMinutes($event, data, 2)"></dx-number-box>
    </div>
    <div *dxTemplate="let data of 'wednesdayCellTemplate'">
      <span>{{data.data.WednesdayToHHmm}}</span>
    </div>
    <div *dxTemplate="let data of 'wednesdayEditCellTemplate'">
      <dx-box direction="row"
              width="100%">
        <dxi-item  [ratio]="2">
          <dx-number-box [value]="getValueHours(data)" [min]="0" [max]="24" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownHH($event)" (onValueChanged)="onValueChangedHours($event, data, 3)" placeholder="{{placeholderShortHours}}"></dx-number-box>
        </dxi-item>
        <dxi-item [ratio]="2">
          <dx-number-box [value]="getValueMin(data)" [min]="0" [max]="59" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownMinutes($event, data, 3)" (onValueChanged)="onValueChangedMinutes($event, data, 3)" placeholder="{{placeholderShortMinutes}}"></dx-number-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *dxTemplate="let data of 'thursdayCellTemplate'">
      <span>{{data.data.ThursdayToHHmm}}</span>
    </div>
    <div *dxTemplate="let data of 'thursdayEditCellTemplate'">
      <dx-box direction="row"
              width="100%">
        <dxi-item  [ratio]="2">
          <dx-number-box [value]="getValueHours(data)" [min]="0" [max]="24" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownHH($event)" (onValueChanged)="onValueChangedHours($event, data, 4)" placeholder="{{placeholderShortHours}}"></dx-number-box>
        </dxi-item>
        <dxi-item [ratio]="2">
          <dx-number-box [value]="getValueMin(data)" [min]="0" [max]="59" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownMinutes($event, data, 4)" (onValueChanged)="onValueChangedMinutes($event, data, 4)" placeholder="{{placeholderShortMinutes}}"></dx-number-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *dxTemplate="let data of 'fridayCellTemplate'">
      <span>{{data.data.FridayToHHmm}}</span>
    </div>
    <div *dxTemplate="let data of 'fridayEditCellTemplate'">
      <dx-box direction="row"
              width="100%">
        <dxi-item  [ratio]="2">
          <dx-number-box [value]="getValueHours(data)" [min]="0" [max]="24" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownHH($event)" (onValueChanged)="onValueChangedHours($event, data, 5)" placeholder="{{placeholderShortHours}}"></dx-number-box>
        </dxi-item>
        <dxi-item [ratio]="2">
          <dx-number-box [value]="getValueMin(data)" [min]="0" [max]="59" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownMinutes($event, data, 5)" (onValueChanged)="onValueChangedMinutes($event, data, 5)" placeholder="{{placeholderShortMinutes}}"></dx-number-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *dxTemplate="let data of 'saturdayCellTemplate'">
      <span>{{data.data.SaturdayToHHmm}}</span>
    </div>
    <div *dxTemplate="let data of 'saturdayEditCellTemplate'">
      <dx-box direction="row"
              width="100%">
        <dxi-item  [ratio]="2">
          <dx-number-box [value]="getValueHours(data)" [min]="0" [max]="24" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownHH($event)" (onValueChanged)="onValueChangedHours($event, data, 6)" placeholder="{{placeholderShortHours}}"></dx-number-box>
        </dxi-item>
        <dxi-item [ratio]="2">
          <dx-number-box [value]="getValueMin(data)" [min]="0" [max]="59" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownMinutes($event, data, 6)" (onValueChanged)="onValueChangedMinutes($event, data, 6)" placeholder="{{placeholderShortMinutes}}"></dx-number-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *dxTemplate="let data of 'sundayCellTemplate'">
      <span>{{data.data.SundayToHHmm}}</span>
    </div>
    <div *dxTemplate="let data of 'sundayEditCellTemplate'">
      <dx-box direction="row"
              width="100%">
        <dxi-item  [ratio]="2">
          <dx-number-box [value]="getValueHours(data)" [min]="0" [max]="24" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownHH($event)" (onValueChanged)="onValueChangedHours($event, data, 7)" placeholder="{{placeholderShortHours}}"></dx-number-box>
        </dxi-item>
        <dxi-item [ratio]="2">
          <dx-number-box [value]="getValueMin(data)" [min]="0" [max]="59" [disabled]="data.data.StatusId === 4" (onFocusIn)="focusHHmm($event)" (onKeyDown)="onKeyDownMinutes($event, data, 7)" (onValueChanged)="onValueChangedMinutes($event, data, 7)" placeholder="{{placeholderShortMinutes}}"></dx-number-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *dxTemplate="let data of 'copyCellTemplate'">
      <a [text]="copyText" class="dx-link dx-link-copy" (click)="onCopyRow($event, data)">Copy</a>
    </div>
    <div *dxTemplate="let data of 'deleteCellTemplate'">
        <!-- <dx-button icon="trash" (onClick)="onCopyRow($event, data)"></dx-button> -->
        <!-- <a class="dx-link dx-link-edit dx-icon-delete" (click)="onDeleteRow($event, data)"> -->
            <i class=" dx-icon-delete" (click)="onDeleteRow($event, data)"></i>
        <!-- </a> -->
    </div>
    
    <dxo-summary [calculateCustomSummary]="calculateSummary">
      <dxi-total-item
        name="customSumMonday"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="MondaySeconds">
      </dxi-total-item>
      <dxi-group-item
        name="customSumMonday"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="MondaySeconds">
      </dxi-group-item>
      <dxi-total-item
        name="customSumTuesday"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="TuesdaySeconds">
      </dxi-total-item>
      <dxi-group-item
        name="customSumTuesday"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="TuesdaySeconds">
      </dxi-group-item>
      <dxi-total-item
        name="customSumWednesday"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="WednesdaySeconds">
      </dxi-total-item>
      <dxi-group-item
        name="customSumWednesday"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="WednesdaySeconds">
      </dxi-group-item>
      <dxi-total-item
        name="customSumThursday"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="ThursdaySeconds">
      </dxi-total-item>
      <dxi-group-item
        name="customSumThursday"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="ThursdaySeconds">
      </dxi-group-item>
      <dxi-total-item
        name="customSumFriday"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="FridaySeconds">
      </dxi-total-item>
      <dxi-group-item
        name="customSumFriday"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="FridaySeconds">
      </dxi-group-item>
      <dxi-total-item
        name="customSumSaturday"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="SaturdaySeconds">
      </dxi-total-item>
      <dxi-group-item
        name="customSumSaturday"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="SaturdaySeconds">
      </dxi-group-item>
      <dxi-total-item
        name="customSumSunday"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="SundaySeconds">
      </dxi-total-item>
      <dxi-group-item
        name="customSumSunday"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="SundaySeconds">
      </dxi-group-item>
      <dxi-total-item
        name="customSumTotal"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="copyColumn">
      </dxi-total-item>
      <dxi-group-item
        name="customSumTotal"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="copyColumn">
      </dxi-group-item>
    </dxo-summary>

  </dx-data-grid>
</div>

<dx-popup
  class="popup"
  [width]="350"
  [height]="300"
  [showTitle]="true"
  title="Project"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
      <p>
        Customer:
        <dx-select-box [dataSource]="customerPopupDataSource"
          displayExpr="Name"
          valueExpr="CustomerId"
          [searchEnabled]="true"
          (onValueChanged)="onPopupCustomerChanged($event)"
          [value]="selectedCustomerIdPopup"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p>
        Project:
        <dx-select-box [dataSource]="projectsPopupDataSource"
          displayExpr="ProjectDisplayName"
          searchExpr="ProjectDisplayName"
          valueExpr="ProjectId"
          [searchEnabled]="true"
          (onSelectionChanged)="onPopupProjectChanged($event)"
          [value]="selectedProjectIdPopup"
          [placeholder]="placeholderProjectSelectSearch"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p>
        <dx-button text="Ok" (onClick)="onClickPopupSelectedProject($event)">

        </dx-button>
      </p>
  </div>
</dx-popup>